export default __webpack_public_path__ + "static/media/image-study-board-2-w@3x.f60c54b9.png";